import React from 'react';
import { MetricCard } from '../../metrics/MetricCard';
import { Users, MessageSquare, CheckCircle } from 'lucide-react';
import { useStore } from '../../../store/useStore';
import { motion } from 'framer-motion';

export const CfoMetrics: React.FC = () => {
  const messages = useStore((state) => state.messages);
  const tasks = useStore((state) => state.tasks);
  const employees = useStore((state) => state.availableUsers);
  
  const completedTasks = tasks.filter(task => task.status === 'COMPLETED').length;
  const totalTasks = tasks.length;
  const completionRate = totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;

  const metrics = [
    {
      title: "Task Completion",
      value: `${completionRate}%`,
      icon: <CheckCircle />,
      trend: `${completedTasks} of ${totalTasks} tasks`,
      color: "emerald"
    },
    {
      title: "Team Members",
      value: employees.length.toString(),
      icon: <Users />,
      trend: "Active employees",
      color: "blue"
    },
    {
      title: "Communications",
      value: messages.length.toString(),
      icon: <MessageSquare />,
      trend: "Total messages",
      color: "purple"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {metrics.map((metric, index) => (
        <motion.div
          key={metric.title}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
        >
          <MetricCard {...metric} />
        </motion.div>
      ))}
    </div>
  );
};